"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _algolia = _interopRequireDefault(require("./algolia.js"));
var _assignments = _interopRequireDefault(require("./b2b/assignments.js"));
var _boardExamDates = _interopRequireDefault(require("./boardExamDates.js"));
var _categories = _interopRequireDefault(require("./categories.js"));
var _clinicalPearls = _interopRequireDefault(require("./clinicalPearls.js"));
var _cme = _interopRequireDefault(require("./cme.js"));
var _cmeCoach = _interopRequireDefault(require("./cmeCoach.js"));
var _cmeTracker = _interopRequireDefault(require("./cmeTracker.js"));
var _creditCards = _interopRequireDefault(require("./creditCards.js"));
var _deviceRegistrations = _interopRequireDefault(require("./deviceRegistrations.js"));
var _examTemplates = _interopRequireDefault(require("./b2b/examTemplates.js"));
var _highlights = _interopRequireDefault(require("./highlights.js"));
var _hubspot = _interopRequireDefault(require("./hubspot.js"));
var _memberGroups = _interopRequireDefault(require("./b2b/memberGroups.js"));
var _modal = _interopRequireDefault(require("./modal.js"));
var _notes = _interopRequireDefault(require("./notes.js"));
var _notifications = _interopRequireDefault(require("./notifications.js"));
var _offline = _interopRequireDefault(require("./offline.js"));
var _organizations = _interopRequireDefault(require("./b2b/organizations.js"));
var _organizationalMemberships = _interopRequireDefault(require("./b2b/organizationalMemberships.js"));
var _performance = _interopRequireDefault(require("./performance.js"));
var _practiceExams = _interopRequireDefault(require("./practiceExams.js"));
var _questionBankProducts = _interopRequireDefault(require("./questionBankProducts.js"));
var _questionBanks = _interopRequireDefault(require("./questionBanks.js"));
var _questions = _interopRequireDefault(require("./questions.js"));
var _quizzes = _interopRequireDefault(require("./quizzes.js"));
var _reports = _interopRequireDefault(require("./b2b/reports.js"));
var _responses = _interopRequireDefault(require("./responses.js"));
var _riskAssessment = _interopRequireDefault(require("./riskAssessment.js"));
var _session = _interopRequireDefault(require("./session.js"));
var _staticData = _interopRequireDefault(require("./staticData.js"));
var _strikeThroughs = _interopRequireDefault(require("./strikeThroughs.js"));
var _subscriptions = _interopRequireDefault(require("./subscriptions.js"));
var _users = _interopRequireDefault(require("./users.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var Actions = /*#__PURE__*/_createClass(function Actions(api, Config) {
  _classCallCheck(this, Actions);
  this.api = api;
  this.Algolia = new _algolia.default(Config.algolia);
  this.Assignments = new _assignments.default(this.api);
  this.Assignments.assignmentsFetch.getKey = this.Assignments.getAssignmentsFetchKey;
  this.BoardExamDates = new _boardExamDates.default(this.api);
  this.Categories = new _categories.default(this.api);
  this.ClinicalPearls = new _clinicalPearls.default(this.api);
  this.CmeCoach = new _cmeCoach.default(this.api);
  // see comment above this.CME.cmeCalculate assignment
  this.CmeCoach.cmeCoachSearch.getKey = this.CmeCoach.cmeCoachSearchKey;
  this.CmeCoach.cmeCoachSendEmail.getKey = this.CmeCoach.cmeCoachSendEmailKey;
  this.CreditCards = new _creditCards.default(this.api);
  this.CreditCards.creditCardRemove.getKey = this.CreditCards.getCreditCardRemoveKey;
  this.DeviceRegistrations = new _deviceRegistrations.default(this.api);
  this.ExamTemplates = new _examTemplates.default(this.api);
  this.Highlights = new _highlights.default(this.api);
  this.Hubspot = new _hubspot.default(Config.hubspot);
  this.MemberGroups = new _memberGroups.default(this.api);
  this.Modal = new _modal.default();
  this.Notes = new _notes.default(this.api);
  this.Notifications = new _notifications.default(this.api);
  this.Offline = new _offline.default(this.api);
  this.OrganizationalMemberships = new _organizationalMemberships.default(this.api);
  this.Organizations = new _organizations.default(this.api);
  this.Performance = new _performance.default(this.api);
  this.RiskAssessment = new _riskAssessment.default(this.api);
  this.RiskAssessment.riskFetch.getKey = this.RiskAssessment.riskFetchKey;
  this.Reports = new _reports.default(this.api);
  this.Responses = new _responses.default(this.api);
  this.Responses.responseEvaluate.getKey = this.Responses.responseEvaluateKey;
  this.Responses.responseSync.getKey = this.Responses.responseSyncKey;
  this.Responses.responseTimeSpent.getKey = this.Responses.responseTimeSpentKey;
  this.Performance.performanceResponsesFetch.getKey = this.Performance.performanceResponsesFetchKey;
  this.Performance.performanceQuizzesFetch.getKey = this.Performance.performanceQuizzesFetchKey;
  this.Performance.performanceQuestionsFetch.getKey = this.Performance.performanceQuestionsFetchKey;
  this.Performance.performancePeersFetch.getKey = this.Performance.performancePeersFetchKey;
  this.Performance.performanceAllStudentsFetch.getKey = this.Performance.performanceAllStudentsFetchKey;
  this.Performance.performanceSchoolPeersFetch.getKey = this.Performance.performanceSchoolPeersFetchKey;
  this.Quizzes = new _quizzes.default(this.api);
  this.Quizzes.quizFetchPerformance.getKey = this.Quizzes.getQuizFetchPerformanceKey;
  this.Quizzes.quizFetchPractice.getKey = this.Quizzes.getQuizFetchPracticeKey;
  this.Quizzes.quizFetchNew.getKey = this.Quizzes.getQuizFetchNewKey;
  this.Quizzes.quizSubmit.getKey = this.Quizzes.getQuizSubmitKey;
  this.Quizzes.quizArchive.getKey = this.Quizzes.getArchiveQuizKey;
  this.Quizzes.quizUnarchive.getKey = this.Quizzes.getUnarchiveQuizKey;
  this.Quizzes.quizzesUnsetOfflineDeviceUuid.getKey = this.Quizzes.getQuizzesUnSetOfflineDeviceUuidKey;
  this.Quizzes.quizQuestionFetchNext.getKey = this.Quizzes.getQuestionNextKey;
  this.Quizzes.quizFetchQuestions.getKey = this.Quizzes.quizFetchQuestionsKey;
  this.Quizzes.quizFetchTake.getKey = this.Quizzes.quizFetchTakeKey;
  this.Quizzes.ltiQuizFetchTake.getKey = this.Quizzes.ltiQuizFetchTakeKey;
  this.Quizzes.quizzesFetch.getKey = this.Quizzes.getQuizzesFetchKey;
  this.Quizzes.quizzesCreatePractice.getKey = this.Quizzes.getQuizCreatePracticeKey;
  this.Quizzes.quizzesCreate.getKey = this.Quizzes.getQuizCreateKey;
  this.Quizzes.quizzesCreateCAT.getKey = this.Quizzes.getQuizCreateCatKey;
  this.Quizzes.quizzesQuickCreate.getKey = this.Quizzes.getQuizQuickCreatekey;
  this.Quizzes.quizSeenQuestion.getKey = this.Quizzes.getQuizSeenKey;
  this.Quizzes.quizEndQuizBlock.getKey = this.Quizzes.getEndQuizBlockKey;
  this.Quizzes.quizTickSync.getKey = this.Quizzes.getQuizTickSyncKey;
  this.Quizzes.quizzesArchive.getKey = this.Quizzes.getArchiveQuizzesKey;
  this.Quizzes.quizzesUnarchive.getKey = this.Quizzes.getUnarchiveQuizzesKey;
  this.Quizzes.quizzesSetOfflineDeviceUuid.getKey = this.Quizzes.getQuizzesSetOfflineDeviceUuidKey;
  this.Quizzes.quizFetchResponses.getKey = this.Quizzes.getQuizFetchResponsesKey;
  this.Quizzes.quizFetchTake.getKey = this.Quizzes.quizFetchTakeKey;
  this.Quizzes.quizzesCreatePractice.getKey = this.Quizzes.getQuizCreatePracticeKey;
  this.Quizzes.ltiQuizFetchTake.getKey = this.Quizzes.ltiQuizFetchTakeKey;
  this.Cme = new _cme.default(this.api, this.Performance);
  this.StaticData = new _staticData.default(this.api);
  /* 
  The following assignment is not preferred, but because cmeCalculate is such a complex action,
  it does not fit nicely into the action generator function. Other solutions using Object.prototype to assign
  the value in the file following the class definition work well isolated in the package, but fail when integrated
  into the hosting application (the method call on Cme.prototype returns undefined).
  */
  this.Cme.cmeCalculate.getKey = this.Cme.cmeCalculateKey;
  this.CmeTracker = new _cmeTracker.default(this.api, this.Cme);
  this.CmeTracker.cmeTrackersFetch.getKey = this.CmeTracker.cmeTrackersFetchKey;
  this.PracticeExam = new _practiceExams.default(this.api);
  this.QuestionBankProducts = new _questionBankProducts.default(this.api);
  this.QuestionBankProducts.productsFetch.getKey = this.QuestionBankProducts.getProductsFetchKey;
  this.QuestionBanks = new _questionBanks.default(this.api, this.Performance, Config.browser);
  this.Questions = new _questions.default(this.api);
  this.Questions.questionExcerptsFetch.getKey = this.Questions.getQuestionExcerptsKey;

  // Session assignment
  this.Session = new _session.default(this.api, Config, this.Notifications, this.Performance, this.QuestionBanks);
  this.Session.sessionLogout.getKey = this.Session.getSessionLogoutKey;
  this.Session.sessionLogin.getKey = this.Session.getSessionLoginKey;
  this.Session.sessionAtiLogin.getKey = this.Session.getSessionAtiLoginKey;
  this.Session.sessionLoginLTI.getKey = this.Session.getSessionLoginLTIKey;
  this.Session.sessionCheck.getKey = this.Session.getSessionCheckKey;
  this.StrikeThroughs = new _strikeThroughs.default(this.api);
  this.Subscriptions = new _subscriptions.default(this.api);
  this.Users = new _users.default(this.api);
  this.Users.userSubscriptionsFetch.getKey = this.Users.getUserSubscriptionKey;
  this.Users.userSubscriptionActivate.getKey = this.Users.getUserSubscriptionActivateKey;
});
exports.default = Actions;
;